<div class="container">
	<div class="row custom-wrapper" *ngIf="uploading">
		<div class="col-md-12">
				<div class="group-gap">

					<!-- Upload image -->
					<div class="avatar-upload" (click)="fileInput.click()">
						<div class="avatar-edit">
							<input type='file' id="imageUpload" accept="video/mp4,video/x-m4v,video/*" #fileInput (change)="uploadFile($event)" />
            </div>
            <div class="avatar-preview" *ngIf="uploading">
              <div id="imagePreview"  [style.backgroundImage]="'url('+ imageUrl +')'">

              </div>
            </div>
         
          </div>
        </div>
    </div>
  </div>
  <div *ngIf="!uploading" >
    <div   [innerHtml]="videoUploadedurl"></div>
</div>
</div>